export default __webpack_public_path__ + "static/media/Nxrmal_Lo_Hand_Metalness.a06d3799.tga";